import React from 'react'
import Nav from '../components/Nav'
import Footer from '../components/Footer'
import MainImg from '../components/MainImg'
import PrisingCard from '../components/PrisingCard'
import WorkCard from '../components/Work';

const project = () => {
  return (
    <div>
      <Nav/>
      <MainImg heading="PROJECTS" text="Some of my most Recent works"/>
      <WorkCard/>
      <PrisingCard/>
      <Footer/>
    </div>
  )
}

export default project
